<template>
    <component :is="component" :meta="resolvedMeta" :value="value" />
</template>

<script>
import KpiCardWidget from './widgets/KpiCardWidget.vue'
import PieChartWidget from './widgets/PieChartWidget.vue'
import BarChartWidget from './widgets/BarChartWidget.vue'
import UnsupportedWidget from './widgets/UnsupportedWidget.vue'

const COMPONENTS = {
    card: KpiCardWidget,
    pie: PieChartWidget,
    bar: BarChartWidget
}

const TYPE_TO_DISPLAY = {
    scalar: 'card',
    duration: 'card',
    percentage: 'card',
    group_by: 'pie',
    time_series: 'bar'
}

function inferFromValue(value) {
    if (typeof value === 'number') return 'card'
    if (Array.isArray(value) && value.length > 0) {
        const first = value[0] || {}
        if ('period' in first) return 'bar'
        if ('xLabel' in first || 'value' in first || 'count' in first) return 'pie'
    }
    return null
}

function resolveDisplay(meta, value) {
    if (meta && meta.display && COMPONENTS[meta.display]) {
        return meta.display
    }
    if (meta && meta.display) {
        // Explicit but unsupported (e.g. gauge / line / area until slice 3).
        return meta.display
    }
    if (meta && meta.type && TYPE_TO_DISPLAY[meta.type]) {
        return TYPE_TO_DISPLAY[meta.type]
    }
    return inferFromValue(value)
}

export default {
    name: 'MetricWidget',
    props: {
        meta: { type: Object, required: true },
        value: { default: null }
    },
    computed: {
        resolvedDisplay() {
            return resolveDisplay(this.meta, this.value)
        },
        resolvedMeta() {
            const display = this.resolvedDisplay
            if (display && (!this.meta.display || this.meta.display !== display)) {
                return { ...this.meta, display }
            }
            return this.meta
        },
        component() {
            const display = this.resolvedDisplay
            if (display && COMPONENTS[display]) {
                return COMPONENTS[display]
            }
            // eslint-disable-next-line no-console
            console.warn('[MetricWidget] unsupported display', {
                id: this.meta && this.meta.id,
                display: this.meta && this.meta.display,
                type: this.meta && this.meta.type,
                valueKind: typeof this.value
            })
            return UnsupportedWidget
        }
    }
}
</script>
